(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.factory('ProtocolCategoryService', ['$http', ProtocolCategoryServiceFn]);


    /* main protocol-category service */
    function ProtocolCategoryServiceFn($http) {
        var baseUrl = '/api/protocolcategories/';

        var service = {
            query: query,
            get: get,
            deleteCategory: deleteCategory,
            update: update,
            save: save,
            reorder: reorder
        };

        return service;

        /* get protocol categories */
        function query(showAll) {
            return $http.get(baseUrl + (showAll ? showAll : false));
        }

        /* get protocol category */
        function get(protocolCategoryId) {
            return $http.get(baseUrl + protocolCategoryId);
        }

        /* delete protocol category */
        function deleteCategory(protocolCategoryId) {
            return $http.delete(baseUrl + protocolCategoryId);
        }

        /* update protocol category */
        function update(protocolCategoryId, item) {
            return $http.put(baseUrl + protocolCategoryId, item);
        }

        /* save protocol category */
        function save(item) {
            return $http.post(baseUrl, item);
        }

        /* reorder items */
        function reorder(id, relatedId) {
            return $http.put(baseUrl + 'reorder/' + id + '/' + relatedId);
        }

    }
})();